import createReducer from 'reducers/createReducer';

import { ShopNotification } from 'actions/actionTypes';

const INITIAL_STATE = {
    notificationHub: null,
    notification: {
        id: 0,
        viewCode: '',
        viewTime: 0,
        value: '',
        arguments: null,
        templateGroup: '',
        isRequest: false,
        isConfirm: false,

        isShow: false,
    },

    error: {
        triggered: false,
        message: '',
    },
};

const reducer = createReducer(INITIAL_STATE, {
    [ShopNotification.RESET_ALL_HUB]: (state, action) => {
        state.notificationHub = INITIAL_STATE.notificationHub;
    },

    [ShopNotification.CHANGE_SHOP_NOTIFICATION_HUB]: (state, action) => (state.notificationHub = action.payload),

    [ShopNotification.CHANGE_SHOP_NOTIFICATION]: (state, action) => {
        state.notification.isShow = false;

        state.notification.type = action.payload.type;
        state.notification.data = action.payload.data;
    },
    [ShopNotification.SHOW_SHOP_NOTIFICATION]: (state, action) => {
        state.notification.isShow = action.payload;

        if (action.payload === false) {
            state.notification.id = INITIAL_STATE.notification.id;
            state.notification.viewCode = INITIAL_STATE.notification.viewCode;
            state.notification.viewTime = INITIAL_STATE.notification.viewTime;
            state.notification.value = INITIAL_STATE.notification.value;
            state.notification.arguments = INITIAL_STATE.notification.arguments;
            state.notification.templateGroup = INITIAL_STATE.notification.templateGroup;
            state.notification.isRequest = INITIAL_STATE.notification.isRequest;
            state.notification.isConfirm = INITIAL_STATE.notification.isConfirm;
        }
    },

    [ShopNotification.LOAD_SHOP_NOTIFICATION_INFO_REQUEST]: (state, action) => {
        state.notification.id = action.payload;
    },
    [ShopNotification.LOAD_SHOP_NOTIFICATION_INFO_REQUEST_SUCCESS]: (state, action) => {
        state.notification.id = action.payload.notificationId;
        state.notification.viewCode = action.payload.notificationViewCode;
        state.notification.viewTime = action.payload.notificationViewTime;
        state.notification.value = action.payload.notificationValue;
        state.notification.arguments = action.payload.notificationArguments;
        state.notification.templateGroup = action.payload.notificationTemplateGroup;
        state.notification.isRequest = action.payload.isRequest;
        state.notification.isConfirm = action.payload.isConfirm;

        state.notification.isShow = true;
    },
    [ShopNotification.LOAD_SHOP_NOTIFICATION_INFO_REQUEST_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload,
        };
    },
});

export default reducer;
